import { ExternalLink, MapPin, Plane, Boxes, Sparkles, Map, Antenna, Cable, Satellite } from "lucide-react";

const PROJECTS = [
  {
    name: "mapsfy.com",
    tagline: "Mapový portál pre vizualizáciu dát, manažment samosprávy, správu majetku a daní.",
    company: "EMIS, spol. s r.o.",
    role: "Marketing Manager",
    tags: ["Branding", "Web", "Performance"],
    icon: Map,
    href: "https://mapsfy.com",
  },
    {
    name: "EMIS",
    tagline: "Geopriestorové spravodajstvo a GIS ekosystémy.",
    company: "EMIS, spol. s r.o.",
    role: "Marketing Manager",
    tags: ["Branding", "Web", "Performance"],
    icon: MapPin,
    href: "https://emis-online.sk",
  },
   {
    name: "geovio",
    tagline: "Nástroj na analýzu satelitných a dronových snímok pre veľké aj malé firmy.",
    company: "EMIS, spol. s r.o.",
    role: "Marketing Manager",
    tags: ["GIS", "Strategy", "Visual ID"],
    icon: Boxes,
    href: "https://geovio.com",
  },
  {
    name: "UAVIS",
    tagline: "Mobilné mapovanie, UAV technológia, letecké snímkovanie.",
    company: "EMIS, spol. s r.o.",
    role: "Marketing Manager",
    tags: ["B2B", "Tech", "Brand"],
    icon: Satellite,
    href: "https://uavis.sk",
  },
  {
    name: "Keline",
    tagline: "B2B/B2C brand v segmente štruktúrovanej kabeláže.",
    company: "KRUGEL EXIM",
    role: "Marketing Specialist",
    tags: ["E-commerce", "Brand", "Ads"],
    icon: Cable,
    href: "https://keline.sk",
  },
   {
    name: "Krugel Exim",
    tagline: "Vývoj, výroba a distribúcia pasívnych komponentov pre informačné a komunikačné siete.",
    company: "KRUGEL EXIM",
    role: "Marketing Specialist",
    tags: ["E-commerce", "Brand", "Ads"],
    icon: Antenna,
    href: "https://krugel.sk",
  },
];

export default function Projects() {
  return (
    <section
      id="projekty"
      data-testid="projects-section"
      className="relative py-24 lg:py-32 border-t border-white/[0.06]"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <span className="pill-tag" data-testid="projects-pill">
              <span className="pill-dot"></span>
              03 — Vybrané projekty
            </span>
            <h2 className="mt-6 text-4xl lg:text-6xl font-extrabold tracking-tight leading-[1.02] max-w-2xl">
              Značky, ktoré som
              <br />
              <span className="text-[#C6F432]">posunul ďalej.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-base lg:text-lg">
            Výber z portfólia — od tech značiek cez B2G platformy až po
            spotrebné značky.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-5">
          {PROJECTS.map((p, i) => {
            const Inner = (
              <article
                key={p.name}
                data-testid={`project-card-${i}`}
                className="group relative h-full p-7 lg:p-9 rounded-3xl border border-white/[0.07] bg-gradient-to-br from-white/[0.025] to-white/[0.005] hover:from-[#C6F432]/[0.06] hover:to-white/[0.01] hover:border-[#C6F432]/30 transition-all duration-500 overflow-hidden"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-[#0A0A0A] border border-white/10 flex items-center justify-center">
                      <p.icon className="w-6 h-6 text-[#C6F432]" />
                    </div>
                    <div>
                      <div className="text-[11px] uppercase tracking-[0.18em] text-white/40">
                        {p.company}
                      </div>
                      <div className="text-sm text-white/65">{p.role}</div>
                    </div>
                  </div>
                  <ExternalLink className="w-5 h-5 text-white/25 group-hover:text-[#C6F432] transition-colors" />
                </div>

                <h3 className="mt-8 text-3xl lg:text-4xl font-extrabold tracking-tight">
                  {p.name}
                </h3>
                <p className="mt-2 text-white/55">{p.tagline}</p>

                <div className="mt-7 flex flex-wrap gap-2">
                  {p.tags.map((t) => (
                    <span
                      key={t}
                      className="text-[11px] font-mono uppercase tracking-wider px-2.5 py-1 rounded-md bg-white/[0.04] border border-white/[0.07] text-white/65"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <div className="absolute -bottom-20 -right-20 w-56 h-56 rounded-full bg-[#C6F432]/[0.06] blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" />
              </article>
            );
            return p.href ? (
              <a key={p.name} href={p.href} target="_blank" rel="noopener noreferrer" className="h-full">
                {Inner}
              </a>
            ) : (
              <div key={p.name} className="h-full">{Inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
